import { renderSlot as _renderSlot, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-bdc86e4e")

_pushScopeId("data-v-bdc86e4e")
const _hoisted_1 = { class: "checkbox" }
const _hoisted_2 = { class: "checkbox-ui d-ib v-middle" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Icon = _resolveComponent("Icon")

  return (_openBlock(), _createBlock("label", _hoisted_1, [
    _renderSlot(_ctx.$slots, "prefix", {}, undefined, true),
    _withDirectives(_createVNode("input", {
      checked: _ctx.isChecked,
      type: "checkbox",
      onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggle($event.target.checked)))
    }, null, 40, ["checked"]), [
      [_vShow, false]
    ]),
    _createVNode("span", _hoisted_2, [
      _createVNode(_component_Icon, {
        class: "check",
        name: "check",
        sm: ""
      })
    ]),
    _renderSlot(_ctx.$slots, "default", {}, undefined, true)
  ]))
})